import {Component, Input, Output, EventEmitter} from '@angular/core';
import {IAppState} from '../store/state/app.state';
import {Store} from '@ngrx/store';
import { DialogPosition, MatDialog } from '@angular/material/dialog';
import {DataDialogConfirmComponent} from './data-dialog-confirm/data-dialog-confirm.component';
import {GetMessage} from '../store/actions/message.actions';
import {IMessage} from '../models/message.interface';
import {IIdentify} from '../models/identify.interface';
import {IRace} from '../models/race.interface';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./_alert-message.theme.scss']
})
export class AlertMessageComponent {
  @Input() message: IMessage;
  @Input() idenify: IIdentify;
  @Input() qAcc: any;
  @Input() race?: IRace;
  @Output() addBetAcc = new EventEmitter();

  constructor(
      private _store: Store<IAppState>,
      public dialog: MatDialog
  ) {}

  refresh(): void {

    const dialogRef = this.dialog.open(DataDialogConfirmComponent, {
      data: {
        type: 'message',
        title: 'MESSAGE.CONFIRM_TITLE',
        text: 'MESSAGE.CONFIRM_MSG',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._store.dispatch(new GetMessage(null));
        window.location.reload();
      }
    });
  }

  viewCombination(): void {
    const dialogPosition: DialogPosition = {
      top: (window.innerWidth > 1199) ? '150px' : null,
    };
    this.dialog.open(DataDialogConfirmComponent, {
      data: {
        type: 'combination',
        title: 'MESSAGE.CONFIRM_TITLE',
        text: 'MESSAGE.CONFIRM_MSG',
        symbol: this.idenify.symbol
      },
      panelClass: ['dialog-combination'],
      position: dialogPosition,
      width: '540px',
      maxWidth: '95vw',
    });
  }

  viewQuoteMigliori(textScommessa): void {
    const dialogPosition: DialogPosition = {
      top: (window.innerWidth > 1199) ? '150px' : null,
    };
    // console.log(this.qAcc);
    const dialogRef = this.dialog.open(DataDialogConfirmComponent, {
      data: {
        type: 'acc_top',
        qAcc: this.qAcc,
        text: textScommessa,
        race: this.race
      },
      panelClass: ['dialog-combination'],
      position: dialogPosition,
      minWidth: '75vw',
      maxWidth: '95vw',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data) {
        this.addBetAcc.emit(result.data);
      }
    });
  }

}

